module.exports = __webpack_public_path__ + "img/湖南三友环保科技有限公司.252e3641.png";